import { GraphQLRequest } from 'msw';

import { getEnvironment } from '@trqk/utils';

import * as publisherDataCognitoIDP from '../cognito/data/users/publisher/cognitoIDP';

const environment = getEnvironment();

/**
 * @param req - the `req` argument passed to a msw graphql handler
 * @param userType - the {@link TestUserType}
 * @returns true when the request has a token which matches the `idToken` that was returned by
 * the cognitoIDPHandler
 */
export const hasValidToken = (
    req: GraphQLRequest<Record<string, unknown>>,
    userType: TestUserType,
): boolean => {
    if (userType === 'publisher') {
        const requestToken = req.headers.get('Authorization');

        return (
            requestToken ===
            publisherDataCognitoIDP.passwordVerifierResponse[environment]
                .AuthenticationResult.IdToken
        );
    }

    return false;
};
